module.exports = __webpack_public_path__ + "static/media/off_icon.e4d5c243.svg";